var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7202C7",
    d: "M57,-41.8C68.7,-30.8,69.6,-7.4,63.6,12.8C57.6,33,44.9,49.9,28.4,57C12,64.2,-8.2,61.5,-25.9,53.2C-43.6,44.9,-58.8,30.9,-65.2,12.2C-71.6,-6.5,-69.2,-29.9,-56.8,-41.1C-44.5,-52.3,-22.3,-51.4,0.2,-51.5C22.6,-51.7,45.3,-52.9,57,-41.8Z",
    transform: "translate(100 100)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.9eef086a3cb599c27a16450923aa791e.svg";
export { ForwardRef as ReactComponent };